export default __webpack_public_path__ + "static/media/photo--sm--62.7d1cd367.jpg";